export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ10.a1dcb0d6.mp3";